import { render, staticRenderFns } from "./ProductHierarchy.vue?vue&type=template&id=e6d18920&"
import script from "./ProductHierarchy.vue?vue&type=script&lang=js&"
export * from "./ProductHierarchy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports